import type { VoidFunctionComponent } from 'react';

import Icon, { icons } from '../Icon';

import styles from './FileTree.module.less';

/**
 * A component that displays an icon indicating that a node is a file.
 */
const FileTreeNodeIcon: VoidFunctionComponent = () => (
  <span className={styles.treeViewNodeIcon}>
    <Icon icon={icons.fileO} />
  </span>
);

export default FileTreeNodeIcon;
